import clsx from 'clsx';
import { SHOW_DRAFT_MARKERS } from '@/config';
import type { Photo } from '@/lib/types';

interface Props {
  photo?: Photo;
  className?: string; // sets the aspect ratio, e.g. "aspect-[4/3]"
}

// A place for a real ITES photograph. Without one it is a plain tinted box while
// we develop (so reviewers see what is still missing) and nothing at all on the
// live site: never an AI image, never placeholder text.
export function PhotoSlot({ photo, className }: Props) {
  if (!photo) return SHOW_DRAFT_MARKERS ? <div aria-hidden="true" className={clsx('bg-sky-50', className)} /> : null;
  return (
    <img
      src={photo.src}
      alt={photo.alt}
      width={photo.width}
      height={photo.height}
      loading="lazy"
      decoding="async"
      className={clsx('block w-full bg-img-fallback object-cover', className)}
    />
  );
}
